import { ReactNode } from 'react';
import {
  ToggleButton as AriaToggleButton,
  ToggleButtonGroup as AriaToggleButtonGroup,
} from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../../ui';

type Item = {
  label: string | ReactNode;
  value: string;
};

type ToggleButtonGroupProps = {
  items: Array<Item>;
  defaultSelectedKey?: Item['value'];
  onChange: (e: Item['value']) => void;
};

export function ToggleButtonGroup(props: ToggleButtonGroupProps) {
  const { items, onChange, defaultSelectedKey } = props;

  return (
    <AriaToggleButtonGroup
      onSelectionChange={(e) => onChange([...e][0].toString())}
      selectionMode="single"
      disallowEmptySelection
      defaultSelectedKeys={[defaultSelectedKey ?? items[0].value]}
      className="flex items-center border border-grayscale100 bg-grayscale50 rounded-6 gap-x-4 h-48 p-2 w-fit"
    >
      {items.map((item) => (
        <AriaToggleButton
          id={item.value}
          key={item.value}
          className={twMerge(
            'px-16',
            'h-full',
            'bg-transparent',
            'rounded-4',
            'data-[selected="true"]:shadow-1',
            'data-[selected="true"]:bg-grayscale0',
            'hover:bg-grayscale100',
          )}
        >
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-primaryMain"
          >
            {item.label}
          </Typography>
        </AriaToggleButton>
      ))}
    </AriaToggleButtonGroup>
  );
}
